import { ChangeEvent, useCallback, useState } from 'react';

export const useCheckboxField = (initialValue = false) => {
  const [checked, setChecked] = useState(initialValue);

  const onChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  }, []);

  return {
    checked,
    onChange,
  };
};

export default useCheckboxField;
